import { axios } from '../utils/http'

// 心跳---获取服务器时间
export const getHeartBeat = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/token/heart')

// 用户端-分享图片二维码短链跳转中转接口

// c8.0 城市列表
export const getCinemaInfoList = (params) => axios({
  method: 'post',
  data: {
    ...params
  }
}, '/cbticket/cbase/cityAndCinemaList')

// 确认支付
export const routePay = (params) => axios(params,  '/pay/routePay/routePay')

// 获取支付列表
export const payWayShow = (params) => axios(params, '/pay/routePay/payWayShow')



// WEBPACK FOOTER //
// ./src/api/api.js